var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66669 12.6667V11.3333H4.00002V6.66667C4.00002 5.74444 4.2778 4.925 4.83335 4.20833C5.38891 3.49167 6.11113 3.02222 7.00002 2.8V2.33333C7.00002 2.05555 7.09724 1.81944 7.29169 1.625C7.48613 1.43055 7.72224 1.33333 8.00002 1.33333C8.2778 1.33333 8.51391 1.43055 8.70835 1.625C8.9028 1.81944 9.00002 2.05555 9.00002 2.33333V2.8C9.88891 3.02222 10.6111 3.49167 11.1667 4.20833C11.7222 4.925 12 5.74444 12 6.66667V11.3333H13.3334V12.6667H2.66669ZM8.00002 14.6667C7.63335 14.6667 7.31947 14.5361 7.05835 14.275C6.79724 14.0139 6.66669 13.7 6.66669 13.3333H9.33335C9.33335 13.7 9.2028 14.0139 8.94169 14.275C8.68058 14.5361 8.36669 14.6667 8.00002 14.6667ZM5.33335 11.3333H10.6667V6.66667C10.6667 5.93333 10.4056 5.30555 9.88335 4.78333C9.36113 4.26111 8.73335 4 8.00002 4C7.26669 4 6.63891 4.26111 6.11669 4.78333C5.59446 5.30555 5.33335 5.93333 5.33335 6.66667V11.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoti);
export default __webpack_public_path__ + "static/media/noti.402644082a6f0dee4335a70fdc8f1c3c.svg";
export { ForwardRef as ReactComponent };